export const formatJSON = (json: any): string => {
  if (!isJSON(json)) return json;

  let result = "";
  let indent = 0;

  // convert single quotes to double quotes
  json = json.replace(/'/g, '"');

  try {
    const jsonObj = JSON.parse(json);

    // convert JSON object to string with double quotes
    json = JSON.stringify(jsonObj, getCircularReplacer());
  } catch (e) {
    // error parsing JSON, return original string
    return json;
  }

  for (let i = 0; i < json.length; i++) {
    const char = json[i];
    if (char === "{" || char === "[") {
      result += char + "\n" + " ".repeat(++indent * 2);
    } else if (char === "}" || char === "]") {
      result += "\n" + " ".repeat(--indent * 2) + char;
    } else if (char === ",") {
      result += char + "\n" + " ".repeat(indent * 2);
    } else {
      result += char;
    }
  }
  return result;
};

const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key: any, value: object | null) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

const isJSON = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const formatArray = (array: any): string => {
  let result = "[\n";
  array.forEach((item: any, index: any) => {
    result += JSON.stringify(item, null, 2);
    if (index < array.length - 1) result += ",\n";
  });
  result += "\n]";
  return result;
};

export const formatDate = (dateString: string) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "invalid date";
  } else {
    return date.toISOString().slice(0, 10);
  }
};
